var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 36,
    viewBox: "0 0 48 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2285_30275)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2343 8.45312C5.02977 8.45312 0 13.1772 0 19.0047V31.5266C0 33.691 1.75457 35.4456 3.91894 35.4456C6.08331 35.4456 7.83788 33.691 7.83788 31.5266V19.0047C7.83788 17.2429 9.35851 15.8147 11.2343 15.8147C13.1101 15.8147 14.6307 17.2429 14.6307 19.0047V26.8846L14.6488 26.8704C14.9422 31.656 18.9162 35.4465 23.7756 35.4465C28.8258 35.4465 32.9198 31.3525 32.9198 26.3023V20.7233H28.8548H25.0807V26.7211C25.0807 27.4426 24.4959 28.0274 23.7744 28.0274C23.0529 28.0274 22.4681 27.4426 22.4681 26.7211V20.7233H22.4675L22.4686 20.7224V19.0047C22.4686 13.1772 17.4388 8.45312 11.2343 8.45312ZM36.3103 8.45312C30.1058 8.45312 25.076 13.1772 25.076 19.0047V20.7224H32.9139V19.0047C32.9139 17.2429 34.4345 15.8147 36.3103 15.8147C38.1861 15.8147 39.7067 17.2429 39.7067 19.0047V31.5266C39.7067 33.691 41.4613 35.4456 43.6257 35.4456C45.79 35.4456 47.5446 33.691 47.5446 31.5266V19.0047C47.5446 13.1772 42.5148 8.45312 36.3103 8.45312Z",
    fill: "#FF065C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2343 8.45215C5.02977 8.45215 0 13.1763 0 19.0037V31.5256C0 33.69 1.75457 35.4446 3.91894 35.4446C6.08331 35.4446 7.83788 33.69 7.83788 31.5256V19.0037C7.83788 17.2419 9.35851 15.8137 11.2343 15.8137C13.1101 15.8137 14.6307 17.2419 14.6307 19.0037V26.8837L22.4686 20.7214V19.0037C22.4686 13.1763 17.4388 8.45215 11.2343 8.45215Z",
    fill: "#1F3FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5283 9.95827C38.0781 14.8934 44.0367 21.8193 47.5485 29.9192V19.0047C47.5485 13.1772 42.5187 8.45312 36.3142 8.45312C34.1979 8.45312 32.2183 9.00273 30.5283 9.95827Z",
    fill: "#FFC26C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2285_30275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 34.9091,
    fill: "white",
    transform: "translate(0 0.545898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/short-logo.39cc86e21c86384207c2b2e7e2ea02f0.svg";
export { ForwardRef as ReactComponent };